$(document).ready(function() {
  const $payByBankAmount = $('#pay-by-bank-amount');

  if ($payByBankAmount.length === 0) {
    return;
  }

  // Prevents pay by bank form submitting on enter.
  $(window).keydown(function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });

  const $chooseBank = $('#chooseBank');

  $($payByBankAmount).on('input', (e) => {
    if (e.target.value !== '') {
      $chooseBank.removeClass('disabled');
    } else {
      $chooseBank.addClass('disabled');
    }
  })
});
